var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypePhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_3003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9256 23.162C17.6565 25.893 22.2263 28.7715 24.6852 25.9286L26.3336 24.2801C27.0927 23.521 27.5509 22.58 26.4493 21.4784L24.716 19.7451C23.4184 18.4475 22.9025 17.4582 21.6052 18.7554L20.8038 19.5568C19.8144 20.5463 17.4636 19.0967 16.2701 17.9031L13.2344 14.8674L10.1986 11.8316C9.00511 10.638 7.55551 8.2873 8.54495 7.29782L9.34634 6.49637C10.6436 5.19912 9.65441 4.68333 8.35659 3.38571L6.62335 1.65252C5.52188 0.551017 4.58073 1.00911 3.82169 1.76815L2.17311 3.41662C-0.669852 5.87543 2.211 10.4453 4.93982 13.1763L9.93263 18.1691L14.9256 23.162Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_3003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.102,
    height: 28.1023,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypePhone);
export default __webpack_public_path__ + "static/media/icon_type_phone.0ca544a1f9b98dd5cb8722c93273afdf.svg";
export { ForwardRef as ReactComponent };